import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import AdminLayout from "../../masterLayout/AdminLayout";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import AdminDataTable from "../../components/admin/AdminDataTable";
import { adminApi, handleAdminLogoutIfNeeded } from "../../utils/adminApi";

const AdminFaqs = () => {
  const [faqs, setFaqs] = useState([]);
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState("");

  const load = async () => {
    const res = await adminApi({ url: "admin/get-all-faq", method: "GET" });
    if (handleAdminLogoutIfNeeded(res)) return;
    if (res.success) setFaqs(res.data || []);
  };

  useEffect(() => {
    document.title = "Admin FAQs";
    load().catch(console.error);
  }, []);

  const save = async (e) => {
    e.preventDefault();
    const res = await adminApi({
      url: "admin/add-faq",
      method: "POST",
      body: form,
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    setMsg(res.msg || (res.success ? "Added" : "Failed"));
    if (res.success) {
      setForm(null);
      load();
    }
  };

  const del = async (row) => {
    if (!window.confirm("Delete this FAQ?")) return;
    const res = await adminApi({
      url: "admin/del-faq",
      method: "POST",
      body: { id: row.id },
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    setMsg(res.msg || (res.success ? "Deleted" : "Failed"));
    if (res.success) load();
  };

  const columns = [
    { key: "id", label: "ID" },
    { key: "que", label: "Question" },
    { key: "ans", label: "Answer" },
    {
      key: "actions",
      label: "Actions",
      render: (_, row) => (
        <button
          type="button"
          className="admin-btn admin-btn-danger"
          style={{ minHeight: 34, padding: "0 10px" }}
          onClick={() => del(row)}
        >
          <Icon icon="lucide:trash-2" width={16} />
        </button>
      ),
    },
  ];

  return (
    <AdminLayout>
      <div className="admin-ui">
        <AdminPageHeader
          title="FAQs"
          subtitle={`${faqs.length} questions shown on the public landing page.`}
          action={
            <button
              type="button"
              className="admin-btn admin-btn-primary"
              onClick={() => setForm({ que: "", ans: "" })}
            >
              <Icon icon="lucide:plus" width={18} />
              Add FAQ
            </button>
          }
        />
        {msg ? <div className="admin-alert admin-alert-info">{msg}</div> : null}

        {form && (
          <div className="admin-form-card">
            <div className="admin-form-head">
              <h6>New FAQ</h6>
              <p>Shown on the public FAQ page.</p>
            </div>
            <form onSubmit={save}>
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label">Question</label>
                  <input
                    className="form-control"
                    placeholder="What is…?"
                    value={form.que}
                    onChange={(e) => setForm({ ...form, que: e.target.value })}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Answer</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    placeholder="Write a clear answer…"
                    value={form.ans}
                    onChange={(e) => setForm({ ...form, ans: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="admin-form-actions" style={{ marginTop: 16 }}>
                <button type="submit" className="admin-btn admin-btn-primary">Save</button>
                <button type="button" className="admin-btn admin-btn-ghost" onClick={() => setForm(null)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        <AdminDataTable columns={columns} rows={faqs} />
      </div>
    </AdminLayout>
  );
};

export default AdminFaqs;
